import { render, staticRenderFns } from "./ParentingArrangementChanges.vue?vue&type=template&id=6f1058c7"
import script from "./ParentingArrangementChanges.vue?vue&type=script&lang=ts"
export * from "./ParentingArrangementChanges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports